import React, { useEffect, useCallback }
    /*useEffect, useRef, useCallback } */
    //, { useReducer }
    from "react"
import { useSelector, useDispatch } from "react-redux"
import { RootReducer } from "../../../components/app/reducer"
import Disclaimer from "../../../components/disclaimer"
import { Link } from "react-router-dom"
import { ResultsCl, TableHeader } from "../../../components/results-table-cl"
import { Depository } from "../../../openapi/depository"
import ExplainDepositoryTypes from "../../../components/depo-search/explain-depo-types"

const DepositoryResults: React.FC = () => {
    const disclaimerAccepted = useSelector((state: RootReducer) => state.appReducer.blnAppDisclaimerAgreed);
    const depositories = useSelector((state: RootReducer) => state.depositoryReducer.depositories);
    const searchCriteria = useSelector((state: RootReducer) => state.depositoryReducer.depSearchCriteria);
    const numberOfDepositories = useSelector((state: RootReducer) => state.depositoryReducer.depositories?.length) || 0;    

    useEffect(() => {
        document.title = "Search for Depository Banks Results"
    }, [])

    const rootDispatch = useDispatch();
    const headerData: TableHeader<Depository> = { code: "Code", name: "Name", city: "City", ctry: "Country", type: "Type" }
    const explainHandler = useCallback(() => {        
        rootDispatch({ type: "App/EXTWINDOWOPEN", content: <ExplainDepositoryTypes locationURL={window.location.protocol + "//" + window.location.hostname + ":" + window.location.port} />, windowTitle: "Depository Types" })
    }, [rootDispatch])

    return (
        <div id="depository-results">
            {/* Disclaimer will not render (retruns null) if accepted */}
            <Disclaimer />
            {disclaimerAccepted &&
                <>
                    <Link to="/depocriteria">Back to Search Criteria</Link>
                    <p className="codelist-header">Search for Depository Banks Results</p>
                    <div>
                        <div>
                            Your query returned the	following results. For more details about a specific Depository, please click on the code.
				        </div>
                    </div>
                    <div>
                        {numberOfDepositories === 1 ? <span> <span className="bold"> 1 </span> Depository found. </span>
                                       : <span> <span className="bold"> {numberOfDepositories} </span> Depositories found. </span>
                        }            
                    </div>
                    <ResultsCl recordsOnPage={10} header={headerData} data={depositories} searchCriteria={searchCriteria}
                        urlCSV="/codelist/v1/Depository/export/csv"
                        urlXML="/codelist/v1/Depository/export/xml"
                        leadingColumnContent={
                            (item: Depository) => (<Link to={`/depo/${item.code}`}>{item.code}</Link>)
                        }
                        customColumnIndex={4}
                        customExplainHandler={explainHandler} />
                </>
            }
        </div>
    )
}

export default DepositoryResults
